import { absolutePath } from "./absolutePath";

interface RecurringEventsFnProps {
  params?: Record<string, unknown>;
  slug?: string;
  spaceId?: string | number;
}

export const recurringEvents = {
  index: ({ slug, spaceId, params = {} }: RecurringEventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/recurring_events`, params),
  rsvp: ({ slug, spaceId, params = {} }: RecurringEventsFnProps = {}) =>
    absolutePath(
      `spaces/${spaceId}/events/${slug}/recurring_events/rsvp`,
      params,
    ),
};
